import { useT } from '../i18n';
/** Shown for the moment a page's code is still on its way. */
export function RouteLoading() {
  const { t } = useT();
  return (
    <p className="muted route-loading" role="status">
      {t('loading')}
    </p>
  );
}
